// TODO: remove this when switching to global workbench version

import { OWCC_WORKBENCH_VERSION } from 'src/build-env';

const WB_LOADER_URL = `https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/${OWCC_WORKBENCH_VERSION}/loader/index.js`;
const WB_TAG_PREFIX = 'ccwb';

/**
 * This adds a script tag to HEAD to define the workbench custom elements using
 * a custom tag name prefix to avoid version conflicts with gobally scoped
 * workbench versions.
 *
 * To avoid a FOUC before workbench components are initialized, there is a call
 * to `window.owcc.workbenchInitialized()` that resolves the promise.
 */
export async function initWorkbench(win: Window): Promise<void> {
  return new Promise(resolve => {
    win.owcc = win.owcc || {};
    win.owcc.workbenchInitialized = () => {
      resolve();
    };
    const wbScript = win.document.createElement('script');
    wbScript.type = 'module';
    wbScript.textContent = [
      `import { defineCustomElements } from '${WB_LOADER_URL}';`,
      `defineCustomElements(window, { transformTagName: (tagName) => \`\${tagName.replace(/^wb-/, '${WB_TAG_PREFIX}-')}\` });`,
      `window.owcc.workbenchInitialized();`
    ].join('');
    win.document.head.append(wbScript);
  });
}
